import angular from "angular";

angular
	.module('app')
	.component('carHistoryMileagePage', {
		template: require('./car-history-mileage-page.html'),
        controller: ['$http', 'moment', controller],
        bindings: {
		    car: '<',
        }
    });
    
function controller($http, moment) {
 
	let $ctrl = this;
	
	$ctrl.$onInit = function () {
        $ctrl.nowDate = moment().format("D.M.Y");
    };
}